export var BoxType;
(function (BoxType) {
  BoxType["modal"] = "modal";
  BoxType["nonModal"] = "nonModal";
})(BoxType || (BoxType = {}));
